import * as React from 'react';
import { ImportTypeEnum } from '@app/common';
import { useTranslation } from 'react-i18next';
import { Platform } from '../../app/platform/platform';
import styles from './partners.module.css';

const brokerPlatforms = [
    { type: ImportTypeEnum.XtbNew, name: 'XTB', width: '8.4rem' },
    { type: ImportTypeEnum.Trading212, name: 'Trading 212', width: '13.5rem' },
    { type: ImportTypeEnum.Degiro, name: 'DEGIRO', width: '12.5rem' },
    { type: ImportTypeEnum.InteractiveBrokers, name: 'Interactive Brokers', width: '18rem' },
    { type: ImportTypeEnum.Etoro, name: 'eToro', width: '8.6rem' },
    { type: ImportTypeEnum.Fio, name: 'Fio', width: '15rem' },
    { type: ImportTypeEnum.Patria, name: 'Patria', width: '11.2rem' },
    { type: ImportTypeEnum.Lynx, name: 'LYNX', width: '10rem' },
    { type: ImportTypeEnum.Revolut, name: 'Revolut', width: '13.2rem' },
    { type: ImportTypeEnum.Portu, name: 'Portu', width: '9.6rem' },
];
const marqueePlatforms = [0, 1, 2].flatMap((repeat) => brokerPlatforms.map((platform) => ({ ...platform, repeat })));

const renderBrokerLogos = (accessible: boolean): React.ReactNode[] =>
    marqueePlatforms.map(({ type, name, width, repeat }) => {
        const original = accessible && repeat === 0;

        return (
            <span
                key={`${repeat}-${type}`}
                role={original ? 'img' : undefined}
                aria-label={original ? name : undefined}
                aria-hidden={original ? undefined : true}
                className={repeat === 0 ? undefined : 'motion-reduce:hidden'}
            >
                <span
                    aria-hidden="true"
                    className="flex h-[3.6rem] items-center [&_svg]:h-auto [&_svg]:w-[calc(var(--broker-width)*0.85)] [&_svg]:max-w-none lg:[&_svg]:w-[var(--broker-width)]"
                    style={{ '--broker-width': width } as React.CSSProperties}
                >
                    <Platform type={type} />
                </span>
            </span>
        );
    });

export const Partners: React.FC = () => {
    const { t } = useTranslation();
    const logoClass = [
        'flex w-max shrink-0 items-center gap-[10rem] pr-[10rem] motion-reduce:pr-0',
        'motion-reduce:w-full motion-reduce:min-w-0 motion-reduce:shrink motion-reduce:flex-wrap motion-reduce:justify-center',
        'motion-reduce:gap-x-[5rem] motion-reduce:gap-y-[2.4rem]',
    ].join(' ');

    return (
        <section
            id="podporovani-brokeri"
            aria-labelledby="supported-brokers-heading"
            className="py-[3.2rem] lg:py-[4rem]"
        >
            <div className="flex items-center gap-[2.4rem] text-[#a99c91] sm:gap-[3.2rem]">
                <span aria-hidden="true" className={styles.divider} />
                <h2
                    id="supported-brokers-heading"
                    className="max-w-[70vw] text-center text-[1.3rem] font-bold uppercase tracking-[0.12em]"
                >
                    {t('pages.homepage.partners.supportedBrokers')}
                </h2>
                <span aria-hidden="true" className={styles.divider} />
            </div>
            <div className="mt-[3.6rem] max-w-[100vw] overflow-hidden text-[#a99c91] [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)] motion-reduce:[mask-image:none]">
                <div className={styles.track}>
                    <div className={logoClass}>{renderBrokerLogos(true)}</div>
                    <div className={`${logoClass} motion-reduce:hidden`} aria-hidden="true">
                        {renderBrokerLogos(false)}
                    </div>
                </div>
            </div>
        </section>
    );
};
